import { TeachingLoadReportType } from '@bp/planung-graphql-types';
import { TimetableReportsTableType } from '../components/EvaluateTimetable/TimetableReportsTable';
import { apiHelper } from './apiHelper';
import { showSuccessCreateToast } from './toast';

export const downloadExcelReport = async (report: TimetableReportsTableType, reportType: TeachingLoadReportType) => {
  await apiHelper<void>({
    method: 'GET',
    path: `/excel/${reportType}/${report.uuid}`,
    type: 'download',
    downloadFileName: 'Excel_Deputate',
  });
};

export const deleteExcelReport = async (report: { uuid: string; name: string }, reportType: TeachingLoadReportType) => {
  await apiHelper<void>({
    method: 'DELETE',
    path: `/excel/${reportType}/${report.uuid}`,
  });
};

export const createTeachingLoadExcelReport = async (schoolYearUuid: string, timetableBlockUuid: string) => {
  const response = await apiHelper<Response>({
    method: 'POST',
    path: `/excel/${schoolYearUuid}/${timetableBlockUuid}`,
  });

  if (response.ok) {
    showSuccessCreateToast();
  }
};

export const createTeachingLoadLelisteReport = async (schoolYearUuid: string, timetableBlockUuid: string) => {
  const response = await apiHelper<Response>({
    method: 'POST',
    path: `/leliste/${schoolYearUuid}/${timetableBlockUuid}`,
  });

  if (response.ok) {
    showSuccessCreateToast();
  }
};

export const createBerlinExcelReport = async (schoolYearUuid: string, timetableBlockUuid: string) => {
  const response = await apiHelper<Response>({
    method: 'POST',
    path: `/excelberlin/${schoolYearUuid}/${timetableBlockUuid}`,
  });

  if (response.ok) {
    showSuccessCreateToast();
  }
};
